export default __webpack_public_path__ + "static/media/3rd.4340fd0d.png";